import styled from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { fontSize } from '../../DashboardSettings/DashboardSettings.styles'
import Button from 'components/UI/Button/Button'

export const Title = styled.h1`
  font-size: ${fontSize.xLarge};
  font-weight: 600;
  color: ${colors.darkPurple};
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
`

export const Note = styled.p`
  color: ${colors.darkTeal};
  font-size: ${fontSize.small};
  text-align: center;
  margin-top: 0px;
  margin-bottom: 40px;
`

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 35px;
`
